import CircularProgress from '@zenbusiness/zui/CircularProgress';

import { CARD_STATUS } from '#client/constants/cards';
import useCardsContext from '#client/hooks/useCardsContext';

import CardDetails from './components/CardDetails';
import GenerateCard from './components/GenerateCard';
import UnfreezeCard from './components/UnfreezeCard';

export default function VirtualCardInfo() {
  const { virtualCard, loadingCard, notHasVirtualCard } = useCardsContext();

  const { status } = virtualCard || {};

  if (loadingCard) {
    return (
      <CircularProgress
        color="inherit"
        size={20}
      />
    );
  }

  if (notHasVirtualCard) {
    return <GenerateCard />;
  }

  if (status === CARD_STATUS.FROZEN) {
    return <UnfreezeCard />;
  }

  if (status === CARD_STATUS.ACTIVE) {
    return <CardDetails />;
  }

  return null;
}
